import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export const verifyInsurance = async ({
  payer_id,
  member_id,
  insured_by,
  group_number,
  user_id,
}: {
  payer_id: string;
  member_id: string;
  insured_by: string;
  group_number?: string;
  user_id: string;
}): Promise<UserProfile> => {
  const { data } = await client.post(`/users/verify_insurance`, {
    payer_id,
    member_id,
    insured_by,
    group_number,
    user_id,
  });
  return data;
};
